<template>
  <div class="contacts" data-aos="fade" data-aos-delay="150">
    <div class="contacts__content">
      <p class="contacts__title h6" v-if="title">
        {{ title }}
      </p>

      <a :href="link.href" class="contacts__link h3" v-if="link"
         target="_blank" rel="nofollow">
        {{ link.text }}
      </a>

      <div class="contacts__icon">
        <Icon name="24/link"/>
      </div>
    </div>
  </div>
</template>

<script>
import Icon from '@/components/Icon/Icon.vue';

export default {
  name: 'Contacts',
  components: { Icon },
  props: {
    data: {
      required: true,
      type: Object,
    },
  },
  computed: {
    title() {
      return this.data.title;
    },
    link() {
      return this.data.link;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "Contacts";
</style>
